import { render, staticRenderFns } from "./MessagesSlideover.vue?vue&type=template&id=2e2c4c0b"
import script from "./MessagesSlideover.vue?vue&type=script&lang=js"
export * from "./MessagesSlideover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports